import PhotoSlideshow, { SlideImage } from '../../../components/feature/PhotoSlideshow';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const features = [
  {
    img: "https://static.readdy.ai/image/faab8405af96b700637a376baf26c6c6/f63ca72a2743e8f7156cc14ad1406dce.png",
    badge: "Launch Monitor",
    title: "UNEEKOR EYE XO2",
    sub: "世界中のプロが愛用。高精度な弾道測定とスイング解析。",
    desc: "世界中のプロが愛用するセンサー。カメラによるスイング解析と高精度な弾道測定で、ゴルフ愛好家から高い評価を得ています。",
    alt: "UNEEKOR EYE XO2弾道測定センサー — シミュレーションゴルフ計測機器",
    reverse: false,
  },
  {
    img: "https://static.readdy.ai/image/faab8405af96b700637a376baf26c6c6/41e1d0bf23947ab4864de26568fd7665.png",
    badge: "1700+ Courses",
    title: "1700+のコース",
    sub: "実在からファンタジーまで。コミュニティで増え続けるコース。",
    desc: "1700以上のコースを収録。コミュニティで作成・共有され、実在コースからファンタジーまで。今も増え続けています。",
    alt: "GSPro シミュレーションゴルフ 1700以上のコース選択画面",
    reverse: true,
  },
  {
    img: "https://static.readdy.ai/image/faab8405af96b700637a376baf26c6c6/3d77084ba50224502fb8ea7e5a737086.png",
    badge: "AI Analysis",
    title: "AIトレーナー",
    sub: "デュアルカメラでフォーム改善のデータを測定。",
    desc: "デュアルカメラで正面と側面からスイングを撮影。フォーム改善のための重要なデータを測定します。初回はインストラクターオプション推奨。",
    alt: "シミュレーションゴルフ AIスイング解析 — デュアルカメラ計測",
    reverse: false,
  },
  {
    img: "https://static.readdy.ai/image/faab8405af96b700637a376baf26c6c6/e9d0f5b8aa834da19d2bcc956c65368c.png",
    badge: "Support",
    title: "無人でも安心",
    sub: "正規代理店スタッフのサポート完備。",
    desc: "正規代理店スタッフによるサポート体制。設定や測定数値の理解など、設備をフル活用するバックアップが完備されています。",
    alt: "Golph.club UNEEKOR正規代理店サポート — 無人シミュレーションゴルフ施設",
    reverse: true,
  },
];

const equipmentSlides: SlideImage[] = [
  {
    src: "https://storage.readdy-site.link/project_files/39d93db1-4ba8-4195-8b83-3f891512ad57/21dc63f6-16c3-4a0e-b9d0-9f6da7a02362_006_1133.jpg?v=0733afb811d6cb3b81c7b5068ed259db",
    alt: "施設写真1",
  },
  {
    src: "https://storage.readdy-site.link/project_files/39d93db1-4ba8-4195-8b83-3f891512ad57/82765124-dcbe-4d7f-9798-756dddca16e6_006_1098.jpg?v=27d5f2b64050d4bdad836367ffbcde5c",
    alt: "施設写真2",
  },
  {
    src: "https://storage.readdy-site.link/project_files/39d93db1-4ba8-4195-8b83-3f891512ad57/8ff2c962-6e57-4fc6-a732-62c6d2f16fc8_003_0642.jpg?v=6a154e1841dec58af1b65a5c0c59fd40",
    alt: "施設写真3",
  },
  {
    src: "https://storage.readdy-site.link/project_files/39d93db1-4ba8-4195-8b83-3f891512ad57/0eb1a8e8-fc0f-44b2-b91a-766e1dd123cd_006_1094.jpg?v=7395783423893abc0cbf1043b3232a8d",
    alt: "施設写真4",
  },
  {
    src: "https://storage.readdy-site.link/project_files/39d93db1-4ba8-4195-8b83-3f891512ad57/ee4d71c2-094d-4f63-81ea-d0d1a726e12c_006_2059.jpg?v=2aeb49a3470d23102ffe6960a718c85b",
    alt: "施設写真5",
  },
];

interface FeatureBlockProps {
  feature: typeof features[0];
  index: number;
}

function FeatureBlock({ feature, index }: FeatureBlockProps) {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <div
      ref={ref}
      className={`flex flex-col ${feature.reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-12 lg:gap-20 transition-all duration-[600ms] ease-out ${
        isVisible
          ? 'opacity-100 translate-x-0'
          : feature.reverse
          ? 'opacity-0 translate-x-10'
          : 'opacity-0 -translate-x-10'
      }`}
      style={{ transitionDelay: `${index * 50}ms` }}
    >
      <div className="w-full lg:w-1/2 flex-shrink-0">
        <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
          <img
            src={feature.img}
            alt={feature.alt}
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
      <div className="w-full lg:w-1/2">
        <span className="inline-block text-[#47d6d4] text-xs font-bold tracking-[0.3em] uppercase mb-4 border border-[#47d6d4] px-3 py-1 rounded-full">
          {feature.badge}
        </span>
        <h3
          className="text-2xl sm:text-3xl font-bold text-[#1a1a3e] mb-4 leading-snug"
          style={{ fontFamily: "'Noto Serif JP', serif", textWrap: 'balance', wordBreak: 'auto-phrase' } as React.CSSProperties}
        >
          {feature.title}
        </h3>
        <p className="text-[#e85d2c] text-sm font-semibold mb-4">{feature.sub}</p>
        <p className="text-[#1a1a3e]/60 text-[19px] leading-[1.85]">{feature.desc}</p>
      </div>
    </div>
  );
}

export default function System() {
  const { ref: headRef, isVisible: headVisible } = useScrollAnimation();
  const { ref: slideRef, isVisible: slideVisible } = useScrollAnimation(0.05);
  const { ref: footerRef, isVisible: footerVisible } = useScrollAnimation();

  return (
    <section id="system" className="py-24 bg-[#f5f5f5]">
      <div className="px-6 lg:px-20 max-w-5xl mx-auto">
        <div
          ref={headRef}
          className={`text-center mb-20 transition-all duration-[600ms] ease-out ${headVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a1a3e] leading-tight"
            style={{ fontFamily: "'Noto Serif JP', serif", textWrap: 'balance', wordBreak: 'auto-phrase' } as React.CSSProperties}
          >
            世界最高峰のテクノロジー。
          </h2>
        </div>

        {/* Feature blocks — 1st & 2nd */}
        <div className="space-y-28 mb-24">
          {features.slice(0, 2).map((f, i) => (
            <FeatureBlock key={i} feature={f} index={i} />
          ))}
        </div>

        {/* ── Equipment Slideshow between features ── */}
        <div
          ref={slideRef}
          className={`mb-24 transition-all duration-[700ms] ease-out ${slideVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-[0.97]'}`}
        >
          <p className="text-center text-[#1a1a3e]/30 text-[11px] tracking-[0.3em] uppercase font-semibold mb-5">Equipment & Screen</p>
          <PhotoSlideshow
            images={equipmentSlides}
            autoPlayInterval={3800}
            aspectRatio="16/9"
            className="w-full"
            overlayDark
          />
        </div>

        {/* Feature blocks — 3rd & 4th */}
        <div className="space-y-28">
          {features.slice(2).map((f, i) => (
            <FeatureBlock key={i + 2} feature={f} index={i + 2} />
          ))}
        </div>

        {/* Footer note + CTA buttons */}
        <div
          ref={footerRef}
          className={`mt-20 text-center transition-all duration-[600ms] ease-out ${footerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <p className="text-[#1a1a3e]/30 text-xs mb-8">UNEEKORの正規販売代理店です</p>
          <div className="flex items-center justify-center">
            <a
              href="https://golph.club/showroom/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 border-2 border-[#47d6d4] text-[#47d6d4] font-bold px-8 py-3.5 rounded-full text-[14px] hover:bg-[#47d6d4]/10 transition-all duration-200 whitespace-nowrap"
            >
              <i className="ri-store-2-line text-base"></i>
              ショールーム・FC加盟のご相談
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
